import { Component } from '@angular/core';

@Component({
  selector: 'app-instagram-icon',
  templateUrl: 'instagram-icon.component.svg',
  standalone: true,
})
export class InstagramIconComponent {
}

